import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AdminComponent } from './admin/admin.component';
import { HomepageComponent } from './homepage/homepage.component';
import { MyAppointmentsComponent } from './admin/my-appointments/my-appointments.component';
import { MyQueriesComponent } from './admin/my-queries/my-queries.component';
import { ChangeHomepageContentsComponent } from './admin/change-homepage-contents/change-homepage-contents.component';
import { UpdateSubjectsComponent } from './admin/update-subjects/update-subjects.component';
import { UpdateServicesComponent } from './admin/update-services/update-services.component';
import { UpdateTestimonialsComponent } from './admin/update-testimonials/update-testimonials.component';
import { AdminPanelComponent } from './admin/admin-panel/admin-panel.component';
import { BookAppointmentComponent } from './homepage/book-appointment/book-appointment.component';
import { SuccessComponent } from './homepage/success/success.component';

//for Ecademic
import { EcaadminDashboardComponent } from './ecaadmin-dashboard/ecaadmin-dashboard.component';
import { EcaadminLoginComponent } from './ecaadmin-login/ecaadmin-login.component';
import { EcasessionsComponent } from './ecaadmin-dashboard/ecasessions/ecasessions.component';
import { EcastudentsComponent } from './ecaadmin-dashboard/ecastudents/ecastudents.component';
import { EcatutorsComponent } from './ecaadmin-dashboard/ecatutors/ecatutors.component';
import { EcasubAdminsComponent } from './ecaadmin-dashboard/ecasub-admins/ecasub-admins.component';
import { EcadashboardComponent } from './ecaadmin-dashboard/ecadashboard/ecadashboard.component';
import { EcasubAdminDashboardComponent } from './ecasub-admin-dashboard/ecasub-admin-dashboard.component';
// //import { HTTP_INTERCEPTORS,HttpClientModule } from '@angular/common/http';
// //import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
// import {SocketService} from './socket.service';
import { AuthGuard } from './ecaservice/Auth.guard';
import { AuthInterceptor } from './ecaservice/auth.interceptor';
import { EcachatroomComponent } from './ecachatroom/ecachatroom.component';
import { EcachatComponent } from './ecachatroom/ecachat/ecachat.component';
import { EcamediaComponent } from './ecachatroom/ecamedia/ecamedia.component';
import { EcaparticipantsComponent } from './ecachatroom/ecaparticipants/ecaparticipants.component';
import { CommonModule } from '@angular/common';
import { ContactUsComponent } from './homepage/contact-us/contact-us.component';
import { TermsAndConditionsComponent } from './homepage/terms-and-conditions/terms-and-conditions.component';
import { CancellationPolicyComponent } from './homepage/cancellation-policy/cancellation-policy.component';
import { PrivacyPolicyComponent } from './homepage/privacy-policy/privacy-policy.component';
import { HeaderComponent } from './homepage/header/header.component';
@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    HomepageComponent,
    MyAppointmentsComponent,
    MyQueriesComponent,
    ChangeHomepageContentsComponent,
    UpdateSubjectsComponent,
    UpdateServicesComponent,
    UpdateTestimonialsComponent,
    AdminPanelComponent,
    BookAppointmentComponent,
    SuccessComponent,

    //ecademic
    EcaadminDashboardComponent,
    EcaadminLoginComponent,
    EcadashboardComponent,
    EcasubAdminDashboardComponent,
    EcachatroomComponent,
    EcasessionsComponent,
    EcastudentsComponent,
    EcasubAdminsComponent,
    EcatutorsComponent,
    EcachatComponent,
    EcamediaComponent,
    EcaparticipantsComponent,
    ContactUsComponent,
    TermsAndConditionsComponent,
    CancellationPolicyComponent,
    PrivacyPolicyComponent,
    HeaderComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    // SocketService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor, multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
